import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d9171fa6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "scene-price-mgmt-list" }

import { useRouter } from 'vue-router';
import {
  XrkTable,
  XrkTableProps,
  useTableColumn,
  BaseButton
} from 'xrk-components';
import { formatter } from '@/utils/';
import { listPage } from '../data-source/apis';
import appStore from '@/store';
import { storeToRefs } from 'pinia';


export default /*#__PURE__*/_defineComponent({
  __name: 'scene-price-mgmt-list',
  setup(__props) {

const router = useRouter();

// 搜索项
const searchConfig: XrkTableProps['searchConfig'] = {
  searchBtn: {
    show: false,
    text: '搜索'
  },
  resetBtn: {
    show: false,
    text: '重置'
  },
  searchColumns: [] as any[],
  otherComponents: []
};

// 列表
const tableConfig: XrkTableProps['tableConfig'] = {
  tableColumns: [
    useTableColumn({
      type: 'index',
      label: '序号',
      width: 80
    }),
    useTableColumn({
      label: '工业名称',
      prop: 'industryName',
      minWidth: 260
    }),
    useTableColumn({
      label: '已开通场景数',
      prop: 'activatedSceneCount',
      align: 'right'
    }),
    useTableColumn({
      label: '最近更新时间',
      prop: 'updateAt',
      minWidth: 180,
      formatter: ({ cellValue }) => formatter.date(cellValue)
    }),
    useTableColumn({
      label: '操作',
      prop: 'handle',
      fixed: 'right',
      width: 120,
      render: ({ row }) => {
        return (
          <BaseButton
            link
            type="primary2"
            onClick={() => {
              router.push({
                path: '/main/industry/scene-price-mgmt/config',
                query: {
                  industry: row.industryName,
                  industryId: String(row.industryId)
                }
              });
            }}
          >
            配置价格
          </BaseButton>
        );
      }
    })
  ] as any[]
};
const { info } = storeToRefs(appStore.useUserStoreSetup);

const getListAjax = async (params: Record<string, any>) => {
  return await listPage({ ...params, industryId: info.value.finalDepId });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(XrkTable), {
      ref: "xrkTableRef",
      getListAjax: getListAjax,
      searchConfig: searchConfig,
      tableConfig: tableConfig
    }, null, 512)
  ]))
}
}

})